(() => {
  const initialized = new WeakSet();
  function initialize() {
    document.querySelectorAll('[data-syn-price-map]').forEach((source) => {
      if (initialized.has(source)) return;
      const root = source.closest('[data-section-type]') || source.closest('.shopify-section');
      const displays = root?.querySelectorAll('[data-syn-price-wrapper] [data-product-price]');
      if (!root || !displays?.length) return;
      let data;
      try { data = JSON.parse(source.textContent); } catch { return; }
      initialized.add(source);
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const form = root.querySelector('form[id^="ProductForm"][action*="/cart/add"]');
        const variantId = String(form?.elements.namedItem('id')?.value || data.initialVariant);
        const prices = data.variants[variantId];
        if (!prices) return;
        const selected = Array.from(root.querySelectorAll('input[data-selling-plan-id]:checked')).find((input) => input.name.endsWith(`_${variantId}`));
        const planId = selected?.dataset.sellingPlanId || form?.elements.namedItem('selling_plan')?.value;
        const value = prices.plans[String(planId)] || prices.initial || prices.base;
        if (value) displays.forEach((display) => {
          if (display.textContent.trim() !== value) display.textContent = value;
        });
      };
      const schedule = () => {
        if (!scheduled) { scheduled = true; queueMicrotask(update); }
      };
      root.addEventListener('change', schedule);
      root.addEventListener('theme:variant:change', schedule);
      const observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) observer.disconnect();
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
